(function () {
	// Slim sticky header (desktop): pinned whenever the full header has
	// scrolled past — no scroll-direction logic. Hidden at the top of the
	// page where the full header is visible.
	function init() {
		var bar = document.querySelector('[data-slim-header]');
		var fullHeader = document.querySelector('body > header');
		if (!bar || !fullHeader) return;

		var mqDesktop = window.matchMedia('(min-width: 992px)');
		var ticking = false;

		function setVisible(on) {
			bar.classList.toggle('on', on);
			bar.setAttribute('aria-hidden', on ? 'false' : 'true');
		}

		function update() {
			ticking = false;
			if (!mqDesktop.matches) {
				setVisible(false);
				return;
			}
			setVisible(window.pageYOffset > fullHeader.offsetTop + fullHeader.offsetHeight);
		}

		window.addEventListener('scroll', function () {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}, { passive: true });

		if (typeof mqDesktop.addEventListener === 'function') {
			mqDesktop.addEventListener('change', update);
		}
		update();

		// Dropdown disclosure. CSS covers mouse hover; focus is managed here so
		// keyboard users get aria state and an exit: the .open class (paired
		// with .slim-nav-item.open .slim-dropdown in theme.css) opens on
		// focus, closes when focus leaves the item, and Escape closes it
		// early — collapsed children leave the tab order, so Escape + Tab
		// skips the rest of a long menu.
		bar.querySelectorAll('.slim-nav-item').forEach(function (item) {
			var dropdown = item.querySelector('.slim-dropdown');
			var link = item.querySelector('.slim-nav-link');
			if (!dropdown || !link) return;
			link.setAttribute('aria-haspopup', 'true');
			link.setAttribute('aria-expanded', 'false');
			var suppress = false; // Escape refocuses the link; don't instantly reopen
			function setOpen(on) {
				item.classList.toggle('open', on);
				link.setAttribute('aria-expanded', on ? 'true' : 'false');
			}
			item.addEventListener('focusin', function () {
				if (!suppress) setOpen(true);
			});
			item.addEventListener('focusout', function (e) {
				if (!item.contains(e.relatedTarget)) {
					suppress = false;
					setOpen(false);
				}
			});
			item.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') {
					suppress = true;
					setOpen(false);
					link.focus();
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
